import { ZoneId } from "@js-joda/core";
import type { FC } from "react";
import { Alert, Form } from "react-bootstrap";
import { useEventCallback } from "usehooks-ts";
import {
	DateRangeSelector,
	type DateRangeValue,
} from "../calendar/DateRangeSelector";
import { usePostsActions } from "../calendar/usePosts";
import { useForm } from "../common/form/useForm";
import { Modal, useModal } from "../common/modal/Modal";
import { Button } from "../components/Button";

export const ModalDeleteScheduledPosts: FC = () => {
	const { close } = useModal();
	const { removeAllScheduled: remove } = usePostsActions();

	const form = useForm({
		initialValues: {
			from: "",
			to: "",
			zone: ZoneId.systemDefault().toString(),
		},
		onSubmit: async (values) => {
			await remove.mutateAsync(values);
			close();
		},
	});

	const handleDatesChange = useEventCallback(
		(value: DateRangeValue | undefined) => {
			if (value === undefined) {
				form.setFieldValue("from", "");
				form.setFieldValue("to", "");
			} else {
				const [from, to] = value;
				form.setFieldValue("from", from.toString());
				form.setFieldValue("to", to.toString());
			}
		},
	);

	return (
		<Modal size="lg">
			<Form onSubmit={form.handleSubmit}>
				<Alert variant="warning">
					You are about to delete all scheduled posts for the selected time
					period.
				</Alert>
				<p>Please select the time period for deleting your scheduled posts!</p>

				<DateRangeSelector onChange={handleDatesChange} className="mb-3" />

				<Button
					loading={remove.isPending}
					icon="delete"
					className="mt-3"
					full
					variant="danger"
					type="submit"
				>
					Delete Posts
				</Button>
			</Form>
		</Modal>
	);
};
